/* eslint-disable space-before-blocks */
import http from '../utils/http';
import axios from 'axios';

export default {
    buscarDadosLoteCadastroViaPlanilha() {
        return http.get({
            url: '/territorios/lote-ar',
            lockScreen: false
        });
    },

    downloadPlanilhaComErro(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: `/territorios/lote-ar/${id}/planilha-feedback`,
                    responseType: 'blob',
                    lockScreen: false
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    previewViaZip(zip) {
        const url = process.env.VUE_APP_HTTP_PATH + '/territorios/lote-ar/preview';

        const formData = new FormData();
        formData.append('arquivo', zip.raw, zip.name);

        return axios.post(url, formData);
    },

    confirmarTerritorios({ itens, nomeArquivo }) {
        return http.post({
            url: '/territorios/lote-ar/confirmar',
            data: { itens, nomeArquivo },
            lockScreen: false
        });
    }
};
